// extracted by mini-css-extract-plugin
module.exports = {"reviewsListing":"ReviewsListing_reviewsListing__GCkH_","imageWrapper":"ReviewsListing_imageWrapper__PwL8E","note":"ReviewsListing_note__oeN9H"};